export default __webpack_public_path__ + "static/media/gwn37.971964f5.webp";